import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextInput, Checkbox } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function FacilitationRailsPage() {
  const [outcome1, setOutcome1] = useState('');
  const [stakeholderLate, setStakeholderLate] = useState('');
  const [riskiestAssumption, setRiskiestAssumption] = useState('');
  const [firstCountermeasure, setFirstCountermeasure] = useState('');
  const [reviewOnCalendar, setReviewOnCalendar] = useState(false);

  return (
    <TaskPage
      phase="engage"
      title="Facilitation Rails & Retrieval Check"
      pageNumber={8}
      instruction="Quick recall to strengthen memory and follow-through. Suggested timing: 60–90 min total (E1 10 · E2 10 · E3 10 · E4 10–15 · E5 10 · E6 10–15 · E7 10–20 · Close 5)"
      whyItMatters="Retrieval prompts at the end of a segment strengthen memory and follow-through; add spaced reviews in later modules for durability."
      coachRail={{
        timing: "3-5 minutes",
        tips: "Opener: 'Name one success signal we could see in 30 days.' Closer: 'One risk I own + first countermeasure.'",
        debrief: "Review date is on the calendar ☐"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Quick Recall</h3>
          <div className="space-y-4">
            <TextInput
              label="Our #1 outcome is"
              value={outcome1}
              onChange={(e) => setOutcome1(e.target.value)}
              placeholder="What's our primary outcome?"
            />
            <div>
              <TextInput
                label="A stakeholder we added late is"
                value={stakeholderLate}
                onChange={(e) => setStakeholderLate(e.target.value)}
                placeholder="Who did we miss initially?"
                className="mb-2"
              />
              <TextInput
                label="(and why)"
                value=""
                onChange={() => {}}
                placeholder="Why did we add them?"
                className="ml-4"
              />
            </div>
            <div>
              <TextInput
                label="The riskiest assumption is"
                value={riskiestAssumption}
                onChange={(e) => setRiskiestAssumption(e.target.value)}
                placeholder="What assumption are we making?"
                className="mb-2"
              />
              <TextInput
                label="Our first countermeasure is"
                value={firstCountermeasure}
                onChange={(e) => setFirstCountermeasure(e.target.value)}
                placeholder="How will we address it?"
                className="ml-4"
              />
            </div>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={reviewOnCalendar}
                onChange={(e) => setReviewOnCalendar(e.target.checked)}
                label="Review date is on the calendar"
              />
            </label>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Facilitation Notes</h3>
          <div className="space-y-2 text-sm text-[var(--text-sec)]">
            <p><strong>Opener:</strong> "Name one success signal we could see in 30 days."</p>
            <p><strong>Closer:</strong> "One risk I own + first countermeasure."</p>
            <p className="mt-4"><strong>Suggested timing:</strong> 60–90 min total</p>
            <ul className="list-disc list-inside ml-4 mt-2">
              <li>E1: 10 min</li>
              <li>E2: 10 min</li>
              <li>E3: 10 min</li>
              <li>E4: 10–15 min</li>
              <li>E5: 10 min</li>
              <li>E6: 10–15 min</li>
              <li>E7: 10–20 min</li>
              <li>Close: 5 min</li>
            </ul>
          </div>
        </div>

        <Callout type="tip" phase="engage">
          <p className="text-sm">Retrieval prompts at the end strengthen memory. Add spaced reviews in later modules for durability.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






